import { Link as Unstyledlink } from "react-router-dom";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const InactiveMessage = styled.div`
  margin-left: 16px;
  margin-right: 8px;
`;

export const NoUrl = styled.div<{ variant: "main" | "env" }>`
  display: flex;
  width: ${props =>
    props.variant === "main" ? "calc(100% - 16px)" : "calc(100% + 48px)"};
  height: 48px;
  box-sizing: border-box;
  margin: ${props =>
    props.variant === "main" ? "0 8px 8px 8px" : " 0 -24px -24px -24px"};
  padding: 12px 16px;
  background-color: var(
    --no-env-section-background-color,
    var(--section-ice-background-color, var(--ice))
  );
  font-size: 14px;
  line-height: 24px;
  ${semiBoldAlias()};
  color: var(--section-slate-color, var(--slate));
`;

export const EnvUrl = styled(NoUrl)`
  background-color: var(
    --main-url-section-background-color,
    var(--section-color-primary-100-background-color, var(--color-primary-100))
  );

  svg {
    min-width: 24px;
    path {
      fill: var(--icon-color-primary-600-fill, var(--theme-primary-700));
    }
  }
  > a {
    white-space: nowrap;
    display: inline-block;
    padding: 0 8px;
    max-width: calc(100% - 32px);
    text-decoration: none;
    position: relative;
    ${props =>
      props.theme.name === "contrast" &&
      `color: var(--link-color-primary-800-color,var(--color-primary-800))`};
    &:hover:after {
      position: absolute;
      display: inline-block;
      content: "";
      width: calc(100% - 16px);
      height: 1px;
      background-color: var(
        --link-color-primary-100-background-color,
        var(--color-primary-100)
      );
      bottom: 0;
      left: 8px;
    }
    &:focus {
      outline: none;
      border: 1px solid
        var(--link-color-primary-800-border-color, var(--color-primary-800));
      border-radius: var(
        --url-container-section-border-radius,
        var(--section-4px-border-radius, var(--4px))
      );
      box-shadow: 0 0 2px
        var(--link-color-primary-800-box-shadow-color, var(--color-primary-800));
      text-decoration: none;
      margin: -1px;
    }
    &:active {
      border: none;
      box-shadow: none;
      text-decoration: underline;
      margin: 0;
    }
  }
`;

export const Truncate = styled.div`
  flex: 1;
  margin-right: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--section-color-primary-600-color, var(--theme-primary-700));
  > div {
    min-width: 0;
    display: unset;
  }
  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const NoEnv = styled.div`
  display: flex;
  margin: 24px 8px 8px 8px;
  padding: 12px 16px;
  align-items: center;
  border-radius: 2px;
  background-color: var(
    --no-env-section-background-color,
    var(--section-ice-background-color, var(--ice))
  );
  font-size: 14px;
  line-height: 24px;
  ${semiBoldAlias()};
  color: var(--section-slate-color, var(--slate));
`;

export const MainUrl = styled(NoEnv)`
  background-color: var(
    --main-url-section-background-color,
    var(--section-color-primary-100-background-color, var(--color-primary-100))
  );
`;

export const DomainLink = styled(Unstyledlink)`
  display: flex;
  line-height: 1;
  svg {
    color: var(--link);
  }
`;

export const ExternalEnvLink = styled.a`
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  white-space: nowrap;
`;

export const EnvUrlBroken = styled(EnvUrl)<{ variant: "env" | "main" }>`
  background-color: var(
    --main-url-section-background-color,
    var(--section-ice-background-color, var(--ice))
  );
  display: flex;
  align-items: center;
  width: ${props => (props.variant === "main" ? "calc(100% - 16px)" : "")};
  margin: ${props => (props.variant === "main" ? "16px 8px 8px 8px" : "")};

  *:last-child {
    svg {
      path {
        fill: var(--mode-vector-neutral-default);
      }
      :hover {
        path {
          fill: var(--icon-slate-fill, var(--slate));
        }
      }
    }
  }

  svg {
    path {
      fill: var(--mode-vector-neutral-strong);
    }
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
